import { render, staticRenderFns } from "./i-wysiwyg.vue?vue&type=template&id=70e0a3f1&scoped=true&"
import script from "./i-wysiwyg.vue?vue&type=script&lang=js&"
export * from "./i-wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./i-wysiwyg.vue?vue&type=style&index=0&id=70e0a3f1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0a3f1",
  null
  
)

export default component.exports